import React from 'react';

export function LoadingSpinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div
      className="flex min-h-[40vh] flex-col items-center justify-center gap-4"
      style={{ color: 'var(--muted)' }}
    >
      <div
        className="h-10 w-10 rounded-full border-2 border-transparent"
        style={{
          borderTopColor: 'var(--accent)',
          borderRightColor: 'var(--accent2)',
          animation: 'rotateLoader 0.8s linear infinite',
        }}
      />
      <span className="text-sm">{label}</span>
    </div>
  );
}
